<template>
  <a
    v-if="usesExternalUrl"
    :href="project.external_url"
    :target="externalTarget"
    :rel="externalRel"
  >
    <slot />
  </a>
  <router-link
    v-else
    :to="{
      name: 'ProjectDetail',
      params: { project_id: project.link },
    }"
  >
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "ProjectLink",
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    usesExternalUrl() {
      return Boolean(this.project.use_external_url && this.project.external_url);
    },
    externalTarget() {
      return this.project.open_external_url_in_new_tab ? "_blank" : null;
    },
    externalRel() {
      return this.project.open_external_url_in_new_tab
        ? "noopener noreferrer"
        : null;
    },
  },
};
</script>
